import React from "react";
import moment from "moment";
import { Grid } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun } from "@fortawesome/free-solid-svg-icons";
import { faTireRugged, faCar, faWarehouse, faSunDust, faSnowflake } from "@fortawesome/pro-regular-svg-icons";
import { withTranslation } from "react-i18next";

import { SEASONS } from "../../../../util/tyre";
import "./index.scss";

const TiresOverview = ({ communication, settings, t }) => {
  const { on_car_tyres, in_storage_tyres } = communication.car;
  if (!on_car_tyres && !in_storage_tyres) return null;

  const getTyreStatus = (tyreProfile, season) => {
    const { all_season_a_threshold, all_season_n_threshold, winter_n_threshold, winter_a_threshold, summer_n_threshold, summer_a_threshold } = settings;

    switch (season) {
      case SEASONS.ALL_SEASON:
        if (tyreProfile < all_season_n_threshold) return "red-status";
        else if (tyreProfile < all_season_a_threshold) return "orange-status";
        else return "green-status";

      case SEASONS.WINTER:
        if (tyreProfile < winter_n_threshold) return "red-status";
        else if (tyreProfile < winter_a_threshold) return "orange-status";
        else return "green-status";

      case SEASONS.SUMMER:
        if (tyreProfile < summer_n_threshold) return "red-status";
        else if (tyreProfile < summer_a_threshold) return "orange-status";
        else return "green-status";

      default:
        return "green-status";
    }
  };

  const getTyreSeasonIcon = season => {
    switch (season) {
      case SEASONS.ALL_SEASON:
        return <FontAwesomeIcon icon={faSunDust} style={{ fontSize: "1.2em", marginLeft: "10px", color: "#21ba45" }} />;

      case SEASONS.WINTER:
        return <FontAwesomeIcon icon={faSnowflake} style={{ fontSize: "1.2em", marginLeft: "10px", color: "#2185d0" }} />;

      case SEASONS.SUMMER:
        return <FontAwesomeIcon icon={faSun} style={{ fontSize: "1.2em", marginLeft: "10px", color: "#fbbd08" }} />;

      default:
        return null;
    }
  };

  const renderTyres = (leftProfile, rightProfile, leftTyre, rightTyre) => {
    if (!leftTyre && !rightTyre) return null;

    return (
      <div className="tyre-checks-section-content-container">
        <div className="tyre-checks-section-inner-container">
          <div className="tyre-checks-section">
            <div className={`tyre-checks-section-box ${getTyreStatus(leftProfile, leftTyre.season)}`}>
              <span>L</span>
            </div>
            <span className="tyre-checks-profile-text">{leftProfile} mm</span>
          </div>
          <div className="tyre-checks-mad-descript-container">
            <div className="tyre-checks-man-descript">
              {leftTyre.manufacturer} {getTyreSeasonIcon(leftTyre.season)}
            </div>
            <div className="tyre-checks-man-descript">{leftTyre.description}</div>
          </div>
        </div>
        <div className="tyre-checks-section-inner-container right-tyre">
          <div className="tyre-checks-section">
            <span className="tyre-checks-profile-text right-profile">{rightProfile} mm</span>
            <div className={`tyre-checks-section-box ${getTyreStatus(rightProfile, rightTyre.season)}`}>
              <span>R</span>
            </div>
          </div>
          <div className="tyre-checks-mad-descript-container">
            <div className="tyre-checks-man-descript">
              {getTyreSeasonIcon(rightTyre.season)} {rightTyre.manufacturer}
            </div>
            <div className="tyre-checks-man-descript">{rightTyre.description}</div>
          </div>
        </div>
      </div>
    );
  };

  const renderTyresSection = (tyres, icon, title) => {
    if (!tyres) return null;

    const { fl_profile, fr_profile, rl_profile, rr_profile, front_left_tyre, front_right_tyre, rear_left_tyre, rear_right_tyre } = tyres;

    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <div className="tyre-checks-sub-heading">
            <FontAwesomeIcon icon={icon} className="tyre-checks-sub-heading-icon" />
            <h4 className="tyre-checks-sub-heading-title">{`${title} ${moment(tyres.updated_on).format("DD-MM-YYYY")}`}</h4>
          </div>
        </Grid.Column>
        <Grid.Column width={8} className="tyre-checks-left-section-container">
          <div className="tyre-checks-section-heading-container">
            <span className="tyre-checks-section-heading-title">{t("cc_FRONT_TYRES").message || "FRONT TYRES"}</span>
          </div>
          {renderTyres(fl_profile, fr_profile, front_left_tyre, front_right_tyre)}
        </Grid.Column>
        <Grid.Column width={8} className="tyre-checks-right-section-container">
          <div className="tyre-checks-section-heading-container">
            <span className="tyre-checks-section-heading-title">{t("cc_REAR_TYRES").message || "REAR TYRES"}</span>
          </div>
          {renderTyres(rl_profile, rr_profile, rear_left_tyre, rear_right_tyre)}
        </Grid.Column>
      </Grid.Row>
    );
  };

  return (
    <Grid className="tyre-checks-container component-container">
      <Grid.Row>
        <Grid.Column width={16}>
          <div className="tyre-checks-heading-container">
            <FontAwesomeIcon icon={faTireRugged} className="tyre-checks-heading-icon" />
            <h2 className="tyre-checks-heading-title">{t("cc_Tire_Overview").message || "Tire Overview"}</h2>
          </div>
        </Grid.Column>
      </Grid.Row>
      {renderTyresSection(on_car_tyres, faCar, t("cc_Tire_control_on_car_datum").message || "Tire - On car - Control date")}
      {renderTyresSection(in_storage_tyres, faWarehouse, t("cc_Tire_control_in_storage_datum").message || "Tire - In storage - Control date")}
    </Grid>
  );
};

export default withTranslation()(TiresOverview);
